const { baseUrl } = require('./src/config/env')
const {
    VUE_APP_PUBLICK_PATH,
    VUE_APP_OUTPUTDIR,
    VUE_APP_API_WINCOURSE_BASE_URL
} = process.env

module.exports = {
    publicPath: VUE_APP_PUBLICK_PATH || '',
    outputDir: VUE_APP_OUTPUTDIR ? 'dist/' + VUE_APP_OUTPUTDIR : 'dist',
    devServer: {
        proxy: {
            '/api': {
                target: baseUrl,
                ws: true,
                pathRewrite: {
                    '^/api': '/api'
                }
            },
            '/drum-boot': {
              target: VUE_APP_API_WINCOURSE_BASE_URL, // 请求本地 需要jeecg-boot后台项目
              ws: false,
              changeOrigin: true,
                pathRewrite: {
                    '^/drum-boot/': '/'
                }
            }
        }
    },
    // configureWebpack: (config) => {
    //     config.module.rules.push({
    //         test: /\.svg$/,
    //         use: [{
    //                 loader: 'svg-sprite-loader',
    //                 options: {}
    //             },
    //             {
    //                 loader: 'svgo-loader',
    //                 options: {
    //                     plugins: [
    //                         // 还有很多配置，具体可以查看https://github.com/svg/svgo
    //                         {
    //                             removeViewBox: false
    //                         },
    //                         {
    //                             removeXMLNS: true
    //                         }
    //                     ]
    //                 }
    //             }
    //         ],
    //         include: ['/src/assets/imgs'] // 把上面去掉的文件夹include进来
    //     });
    // }
};
